// src/views/Business/BusinessProfile.js
import React,{useEffect,useState} from 'react';
import {db} from '../../firebase/firebase.js';
import {doc, getDoc} from 'firebase/firestore';
import { useAuth } from "../../auth/AuthContext";

export default function BusinessProfile(){

  const { user } = useAuth();

  const [biz,setBiz] = useState(null);
  const [branding,setBranding] = useState(null);
  const [loading,setLoading] = useState(true);

  // Always run this hook — React requires consistent hook order
  useEffect(()=>{
    const load = async()=>{

      // ❗ Prevent Firestore crash
      if(!user || !user.businessId){
        setLoading(false);
        return;
      }

      try{
        const infoRef = doc(db, `businesses/${user.businessId}/profile/info`);
        const brandRef = doc(db, `businesses/${user.businessId}/settings/branding`);

        const infoSnap = await getDoc(infoRef);
        const brandSnap = await getDoc(brandRef);

        setBiz(infoSnap.exists()? infoSnap.data() : {});
        setBranding(brandSnap.exists()? brandSnap.data() : {});
      }catch(err){
        console.error("Profile load error:",err);
      }

      setLoading(false);
    };

    load();
  },[user]); // Re-run only when auth user changes


  // SAFE RENDER (no early return before hooks)
  if(loading){
    return(
      <div className="min-h-screen bg-neutral-950 text-white flex items-center justify-center">
        <p className="opacity-60">Loading business profile...</p>
      </div>
    );
  }

  if(!user || !user.businessId){
    return(
      <div className="text-white p-10 text-center">
        Missing Business ID — please re-login.
      </div>
    );
  }


  return(
    <div className="min-h-screen bg-neutral-950 text-white px-6 py-10">
      <div className="max-w-4xl mx-auto">

        <h2 className="text-3xl font-semibold mb-8">Business Profile</h2>

        <div className="bg-neutral-900 rounded-2xl shadow-lg p-6 space-y-6">

          {/* LOGO */}
          {branding?.logoURL && (
            <div className="flex justify-center">
              <img 
                src={branding.logoURL}
                alt="Business Logo"
                className="h-20 object-contain"
              />
            </div>
          )}

          {/* BASIC INFO */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            <div className="bg-neutral-800 rounded-xl p-4">
              <p className="text-neutral-400 text-sm">Business Name</p>
              <p className="text-xl font-semibold">{branding?.customHeader}</p>
            </div>

            <div className="bg-neutral-800 rounded-xl p-4">
              <p className="text-neutral-400 text-sm">Business ID</p>
              <p className="text-xl font-semibold">{user.businessId}</p>
            </div>

            <div className="bg-neutral-800 rounded-xl p-4">
              <p className="text-neutral-400 text-sm">Onboarded</p>
              <p className="text-xl font-semibold">
                {biz?.onboarded ? "Yes" : "No"}
              </p>
            </div>

            <div className="bg-neutral-800 rounded-xl p-4">
              <p className="text-neutral-400 text-sm">Created</p>
              <p className="text-xl font-semibold">
                {biz?.createdAt?.toDate?.().toLocaleString?.() || "-"}
              </p>
            </div>

          </div>

          {/* BUTTONS */}
          <div className="flex gap-4">
            <a
              href="/business/settings"
              className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-xl"
            >
              Edit Branding Settings
            </a>
          </div>

        </div>

      </div>
    </div>
  );
}
